// Phase I (I-C, I3): branding and host information for the web app.
import { useQuery } from '@tanstack/react-query';
import type { BrandingSettings, HostInfo } from '@denwen-msp/shared';
import { api } from '@/lib/api';
import { useApi } from '@/lib/query';

export const HOST_KEY = ['public', 'host'];
export const BRANDING_KEY = ['settings', 'branding'];

const APP_HOST: HostInfo = { kind: 'app', tenant: null, branding: null, staffUrl: null };

/**
 * Which tenant this host belongs to (none on the app domain). Fixed for the page's lifetime. A
 * failure counts as the app domain, so the company-code sign-in always works.
 */
export function useHostInfo() {
  return useQuery({
    queryKey: HOST_KEY,
    queryFn: () => api<HostInfo>('/public/host').catch(() => APP_HOST),
    staleTime: Infinity,
    retry: false,
  });
}

/** The signed-in tenant's branding (readable by every signed-in user). */
export const useBranding = (enabled = true) => useApi<BrandingSettings>(BRANDING_KEY, '/admin/settings/branding', { enabled });
